import useNetwork from './network';
import { IEligibilityModel } from './models/eligibilityModel';

export const createEligibility = async (lang: string, eligibility: IEligibilityModel) => {
    const { createEligibility } = useNetwork();
    const result = await createEligibility(lang, eligibility);

    if (result.status === 204) {
        return true;
    }
    return false;
};
